import { h } from 'preact';
import Current from '../current';
import Forecast from '../forecast';
import Alert from '../alert';
import delve from 'dlv';
import { Text } from 'preact-i18n';
import style from './style';

const Weather = ({
	conditions,
	currentUnit,
	config,
	forecast,
	weatherLink,
	trackingParams,
	clientId,
	alerts,
	weatherAlertUrl,
	changeUnit,
	showRadarFullForecastLink = true,
	showAlerts
}) => (

	<div>
		<div key="container" class={style.container}>
			<Current
				today={conditions}
				unit={currentUnit}
				changeUnit={changeUnit}
			/>
			<Forecast forecasts={forecast.slice(0, 3)} unit={currentUnit} />
		</div>
		<div class={style.moreOnAndradarFullForecast}>
			<div class={style.moreOn}>
				<Text id="moreOn" />
				<a href={weatherLink} target="_blank" rel="noopener noreferrer">
					<Text id="accuWeather" />
				</a>
			</div>
			{ showRadarFullForecastLink &&
				<div class={style.radarFullForecast}>
					{ config.useWeatherChannel ?
						<a
							href={config.radarFullForecastWeatherURL}
							target="_blank"
							rel="noopener noreferrer"
						>
							<Text id="radarFullForecast" />
						</a> :
						<a href={config.weatherVerticalUrl}>
							<Text id="radarFullForecast" />
						</a>
					}
				</div>
			}
		</div>
		{alerts && alerts.description && showAlerts &&
		<Alert
			alertColor={delve(config, 'alertConfig.colorOverride') || alerts.color}
			alertCount={delve(alerts, 'totalAlerts')}
			alertText={alerts.description}
			alertURL={weatherAlertUrl}
			openNewWindow={config.useWeatherChannel}
		/>
		}
	</div>
);
export default Weather;



// WEBPACK FOOTER //
// ../node_modules/@cube/weather-widget/src/components/weather/weather.js